module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURVCr8f///3C79Nfs/KbV+IvI9lmw8r/h+u32/qY3ilwAAACOSURBVDjL3VPZEsQgDBJCNP//xXu028aj2/fy5BhCmKClPBWVdbpKNzQAxkIlgtvBIDYEPBEagvvRdgKsMRMQW0PFgaygr6jqOQFQZ9J+sloKFHdMYOlM3hAWAtFvyiZCG1ap+Dfh42LQsDEN3QiMDC1Cpi4dppgv+umusxw+d3sqqy6fGV3N3lnxmb/oBSFxAnGbn1GiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/twitter.png
// module id = HzLV
// module chunks = 1